import { Box, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme } from "@mui/material"
import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { primary75 } from "src/providers/AppProviders"

interface Props {
  label: string
  hideLabel?: boolean
  path: string
  iconPath: string
  external?: boolean
  open: boolean
  "data-testid": string
  onNavigate?: () => void
}

const NavbarEntry: React.FC<Props> = ({
  label,
  hideLabel,
  path,
  iconPath,
  external,
  open,
  "data-testid": testId,
  onNavigate
}) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { palette } = useTheme()

  const onClick = () => {
    external ? window.open(path, "_blank")?.focus() : navigate(path)
    onNavigate?.()
  }

  return (
    <ListItem
      key={label}
      disablePadding
      sx={{
        display: "block",
        px: open ? { xs: 4, md: 2 } : 1,
        height: 40,
        minHeight: 40
      }}
      onClick={onClick}
    >
      <ListItemButton
        data-testid={testId}
        sx={[
          pathname === path ? { backgroundColor: primary75 } : {},
          {
            px: 1,
            borderRadius: "4px",
            minHeight: 40,
            ":hover": {
              backgroundColor: primary75,
              textShadow: `0 0 .05px ${palette.text.primary}`
            }
          }
        ]}
      >
        <ListItemIcon
          sx={[
            {
              minWidth: 0,
              justifyContent: "center",
              ...(hideLabel && open ? { width: "100%", justifyContent: "left" } : {})
            },
            open ? { mr: 1 } : { mr: 0 }
          ]}
        >
          <Box
            component="img"
            src={iconPath}
            alt=""
            sx={{
              height: hideLabel && open ? "28px" : { xs: "24px", md: "20px" },
              maxWidth: hideLabel ? "none" : { xs: "24px", md: "20px" }
            }}
          />
        </ListItemIcon>
        {open && (
          <ListItemText
            primary={hideLabel ? "" : label}
            primaryTypographyProps={{
              sx: {
                fontSize: { xs: "1rem", md: "0.9rem" },
                background: `linear-gradient(to right, ${palette.text.primary}, 95%,white)`,
                color: "transparent",
                backgroundClip: "text",
                textOverflow: "clip"
              },
              noWrap: true
            }}
            sx={{ m: 0 }}
          />
        )}
      </ListItemButton>
    </ListItem>
  )
}

export default NavbarEntry

export const NavbarDivider = ({ open }: { open: boolean }) => {
  return <Divider sx={{ mx: { xs: 0, md: open ? 2 : 1 } }} />
}
